import React from 'react'
import { Box, Display1, Body1, majorScale } from '@segment/react-ui-library'
import { Button } from 'evergreen-ui'
import sloth from '../../public/images/sloth.svg'

const handleReloadPage = () => window.location.reload()

const ErrorPage = () => (
  <Box display="flex" alignItems="center" justifyContent="center">
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="420px"
    >
      <Box
        is="img"
        src={sloth}
        alt="Segment Sloth"
        marginBottom={majorScale(3)}
      />
      <Display1 marginBottom={majorScale(1)}>Something went wrong...</Display1>
      <Body1 textAlign="center">
        An unexpected error occurred while loading the Segment App. We were
        notified and will try to fix it as soon as possible.
      </Body1>

      <Box display="flex" marginTop={majorScale(2)}>
        <Button
          is="a"
          href="https://segment.com/contact/support"
          appearance="ghost"
          marginRight={majorScale(1)}
        >
          Contact Support
        </Button>
        <Button appearance="green" onClick={handleReloadPage}>
          Reload Page
        </Button>
      </Box>
    </Box>
  </Box>
)

export default ErrorPage
